import { $ } from "@/common/Axios";

export default {
  /**
   * 统计部门
   */
  statisticsDepartment_updateDepartmentId: {
    /*
     * 名单编辑
     * id id (integer query required)
     * departmentIds 部门id (array query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsDepartment/updateDepartmentId",
        p,
        c
      ),
  },
  statisticsDepartment: {
    /*
     * 添加
     * department  ( query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/statisticsDepartment", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/statisticsDepartment", p, c),
  },
  statisticsDepartment_listSysDept: {
    /*
     * 根据统计部门id获取系统部门列表
     * id 统计部门id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listSysDept", p, c),
  },
  statisticsDepartment_listStatsDept: {
    /*
     * 根据分类获取统计部门列表
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listStatsDept", p, c),
  },
  statisticsDepartment_listByClass: {
    /*
     * 列表
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/listByClass", p, c),
  },
  statisticsDepartment_getDepartmentIds: {
    /*
     * 获取部门id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsDepartment/getDepartmentIds", p, c),
  },

  /**
   * 统计分类
   */
  statisticsClassification_updateSuperAdminIds: {
    /*
     * 超级名单编辑
     * id id (integer query required)
     * adminIds 名单id (array query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsClassification/updateSuperAdminIds",
        p,
        c
      ),
  },
  statisticsClassification_updatePositions: {
    /*
     * 角色名单编辑
     * id id (integer query required)
     * positions 角色名单 (array query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsClassification/updatePositions",
        p,
        c
      ),
  },
  statisticsClassification_updateAdminIds: {
    /*
     * 人员名单编辑
     * id id (integer query required)
     * adminIds 名单id (array query )
     */
    put: (p, c) =>
      $.put(
        "/api/bms/statistics/statisticsClassification/updateAdminIds",
        p,
        c
      ),
  },
  statisticsClassification: {
    /*
     * 添加
     * classification  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/statisticsClassification", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/statistics/statisticsClassification", p, c),
  },
  statisticsClassification_setXmtGroup: {
    /*
     * 设置新媒体组别
     * groups 组别 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/statisticsClassification/setXmtGroup", p, c),
  },
  statisticsClassification_statisticsForWechatContact: {
    /*
     * 企业微信服务联系统计分析
     * classificationId 分类id (integer query )
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForWechatContact",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForServiceWechat: {
    /*
     * 服务部企微月触达情况
     * classificationId 分类id (integer query required)
     * year 年 (integer query required)
     * month 月 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForServiceWechat",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForServiceWechatExport: {
    /*
     * 服务部企微月触达情况, 点击数字导出
     * type 0服务学生 1无需绑定 2已绑定 3未绑定 4已触达 5未触达  (integer query required)
     * departmentId 部门ID (integer query )
     * headerTeacherId 班主任ID (integer query )
     * year 年 (integer query required)
     * month 月 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForServiceWechatExport",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForSelfTaughtWechat: {
    /*
     * 自考企微月触达情况
     * classificationId 分类id (integer query required)
     * year 年 (integer query required)
     * month 月 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtWechat",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForSelfTaughtWechatExport: {
    /*
     * 自考企微月触达情况, 点击数字导出
     * type 0服务学生 1无需绑定 2已绑定 3未绑定 4已触达 5未触达  (integer query required)
     * departmentId 部门ID (integer query )
     * headerTeacherId 班主任ID (integer query )
     * year 年 (integer query required)
     * month 月 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtWechatExport",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForSelfTaughtScoreInfo: {
    /*
     * 自考成绩统计整体数据
     * classificationId 分类id (integer query required)
     * category 学生来源 (string query required)
     * sourceSiteIds 学校ids, 学生来源是继教院时 (array query )
     * province 省份 (string query required)
     * examBatch 考期（自考） (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForSelfTaughtScoreInfo",
        p,
        c
      ),
  },
  statisticsClassification_statisticsForAdultEnrollBySiteOrLevel: {
    /*
     * 成教招生数据统计（学校、层次维度）
     * classificationId 分类id (integer query required)
     * timeType 时间类型 (string query )
     * type 类型： 学校维度|层次维度 (string query required)
     * batch 批次 (string query )
     * peer 是否同行 (string query )
     * liveStatus 流失状态 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsForAdultEnrollBySiteOrLevel",
        p,
        c
      ),
  },
  statisticsClassification_statisticsContinueStudentEnrollAdult: {
    /*
     * 继教院报名成教首页统计
     * classificationId 分类id (integer query required)
     * level 继教院层次 (string query required)
     * province 继教院省份 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsContinueStudentEnrollAdult",
        p,
        c
      ),
  },
  statisticsClassification_statisticsAdultGraduateInfo: {
    /*
     * 成教毕业率查看视图-批次|学籍年级维度
     * classificationId 分类id (integer query required)
     * type 维度:批次|学籍年级 (string query required)
     * statuses 学籍状态 (array query required)
     * province 省份 (string query )
     * batches 批次 (array query )
     * rollGrades 学籍年级 (array query )
     * siteType 学校类型 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfo",
        p,
        c
      ),
  },
  statisticsClassification_statisticsAdultGraduateInfoForEdu: {
    /*
     * 成教毕业率查看视图-批次|学籍年级维度 （教务查看，高校负责人看自己）
     * classificationId 分类id (integer query required)
     * type 维度:批次|学籍年级 (string query required)
     * statuses 学籍状态 (array query required)
     * province 省份 (string query )
     * batches 批次 (array query )
     * rollGrades 学籍年级 (array query )
     * siteType 学校类型 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoForEdu",
        p,
        c
      ),
  },
  statisticsClassification_statisticsAdultGraduateInfoExport: {
    /*
     * 成教毕业率, 点击数字导出
     * type 维度:批次|学籍年级 (string query required)
     * statuses 学籍状态, 多选, 正常的学籍状态 (array query )
     * schoolStatus 学籍状态, 正常毕业|延迟毕业|异常|未毕业 (string query )
     * province 省份 (string query )
     * batch 批次 (string query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校ID (integer query )
     * siteType 学校类型 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoExport",
        p,
        c
      ),
  },
  statisticsClassification_statisticsAdultGraduateInfoExportForEdu: {
    /*
     * 成教毕业率, 点击数字导出 （教务查看，高校负责人看自己）
     * type 维度:批次|学籍年级 (string query required)
     * statuses 学籍状态, 多选, 正常的学籍状态 (array query )
     * schoolStatus 学籍状态, 正常毕业|延迟毕业|异常|未毕业 (string query )
     * province 省份 (string query )
     * batch 批次 (string query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校ID (integer query )
     * siteType 学校类型 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/statisticsAdultGraduateInfoExportForEdu",
        p,
        c
      ),
  },
  statisticsClassification_mainInfoForServiceForExport: {
    /*
     * 学历教育首页服务整体数据-服务视角, 点击数字导出
     * type 1异常学生 2休学逾期 3未绑定企微 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForServiceForExport",
        p,
        c
      ),
  },
  statisticsClassification_mainInfoForServiceByEduEnrollForExport: {
    /*
     * 学历教育首页服务整体数据-教务视角(招办学生情况), 点击数字导出
     * type 0异常学生 1上月招生 2本月招生 3上月审核 4本月审核 5剩余未审核  (integer query required)
     * batch 批次,招生数据导出传入 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForServiceByEduEnrollForExport",
        p,
        c
      ),
  },
  statisticsClassification_mainInfoForSelfTaughtServiceForExport: {
    /*
     * 自考平台服务整体数据, 点击数字导出
     * type 1未考试 2未看课程 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/mainInfoForSelfTaughtServiceForExport",
        p,
        c
      ),
  },
  statisticsClassification_list: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/list", p, c),
  },
  statisticsClassification_listXmtSiteTypeEnrollData: {
    /*
     * 获取新媒体各学校类型业绩数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listXmtSiteTypeEnrollData",
        p,
        c
      ),
  },
  statisticsClassification_listXmtGroup: {
    /*
     * 获取新媒体组别
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/listXmtGroup", p, c),
  },
  statisticsClassification_listXmtGroupEnrollData: {
    /*
     * 获取新媒体分组业绩数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listXmtGroupEnrollData",
        p,
        c
      ),
  },
  statisticsClassification_listXmtClueFee: {
    /*
     * 新媒体费用数据
     * timeType 时间类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listXmtClueFee",
        p,
        c
      ),
  },
  statisticsClassification_listSiteStudentForService: {
    /*
     * 学校各状态人数(服务)
     * siteType 学校类型 (string query )
     * rollGrade 学籍年级 (string query )
     * businessId 事业部id (integer query )
     * schoolStatuses 学籍状态 (array query )
     * timeType 时间类型 (string query )
     * start 时间类型 (string query )
     * end 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForService",
        p,
        c
      ),
  },
  statisticsClassification_listSiteStudentForSelf: {
    /*
     * 学校各状态人数(教务)
     * dimension 维度：学校、专业 (string query required)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForSelf",
        p,
        c
      ),
  },
  statisticsClassification_listSiteStudentForEducation: {
    /*
     * 学校各状态人数(教务)
     * siteType 学校类型 (string query )
     * rollGrade 学籍年级 (string query )
     * businessId 事业部id (integer query )
     * schoolStatuses 学籍状态 (array query )
     * timeType 时间类型 (string query )
     * start 时间类型 (string query )
     * end 时间类型 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteStudentForEducation",
        p,
        c
      ),
  },
  statisticsClassification_listSiteHeaderTeacher: {
    /*
     * 班主任带班人数
     * province 省份 (string query )
     * site 学校 (string query )
     * major 专业 (string query )
     * rollGrade 学籍年级 (string query )
     * schoolStatuses 学籍状态 (array query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHeaderTeacher",
        p,
        c
      ),
  },
  statisticsClassification_listSiteHandSchoolForService: {
    /*
     * 上交高校(服务)
     * siteType 学校类型 (string query )
     * handSchoolConfigId 上交高校统计配置 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHandSchoolForService",
        p,
        c
      ),
  },
  statisticsClassification_listSiteHandSchoolForEducation: {
    /*
     * 上交高校(教务)
     * siteType 学校类型 (string query )
     * handSchoolConfigId 上交高校统计配置 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSiteHandSchoolForEducation",
        p,
        c
      ),
  },
  statisticsClassification_listSelfMediaPromotionSummary: {
    /*
     * 自考多媒体推广视图-自媒体业绩汇总
     * timeType 时间类型 (string query )
     * start 开始 (string query )
     * end 结束 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionSummary",
        p,
        c
      ),
  },
  statisticsClassification_listSelfMediaPromotionOverview: {
    /*
     * 自考多媒体推广视图-概览
     * timeType 时间类型 (string query )
     * start 开始 (string query )
     * end 结束 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionOverview",
        p,
        c
      ),
  },
  statisticsClassification_listSelfMediaPromotionLineChartData: {
    /*
     * 自考多媒体推广视图-折线图
     * type 类型：单量、转化率、成交成本、线索成本 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionLineChartData",
        p,
        c
      ),
  },
  statisticsClassification_listSelfMediaPromotionEnroll: {
    /*
     * 自考多媒体推广视图-业绩占比
     * timeType 时间类型 (string query )
     * start 开始 (string query )
     * end 结束 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listSelfMediaPromotionEnroll",
        p,
        c
      ),
  },
  statisticsClassification_listMainInfoForService: {
    /*
     * 学历教育首页服务整体数据-服务视角
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForService",
        p,
        c
      ),
  },
  statisticsClassification_listMainInfoForServiceByEdu: {
    /*
     * 学历教育首页服务整体数据-教务视角(教务学生情况)
     * rollGrade 学籍年级 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForServiceByEdu",
        p,
        c
      ),
  },
  statisticsClassification_listMainInfoForServiceByEduEnroll: {
    /*
     * 学历教育首页服务整体数据-教务视角(招办学生情况)
     * classificationId 分类id (integer query required)
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForServiceByEduEnroll",
        p,
        c
      ),
  },
  statisticsClassification_listMainInfoForSelfTaughtService: {
    /*
     * 自考平台服务整体数据
     * classificationId 分类id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listMainInfoForSelfTaughtService",
        p,
        c
      ),
  },
  statisticsClassification_listHeaderTeacherGraduatePer: {
    /*
     * 成教毕业率，点毕业率弹出查看
     * type 维度:批次|学籍年级 (string query required)
     * statuses 学籍状态 (array query required)
     * province 省份 (string query )
     * batch 批次 (string query )
     * rollGrade 学籍年级 (string query )
     * siteId 学校 (integer query )
     * siteType 学校类型 (string query )
     * level 层次 (string query )
     * peer 是否同行, 默认全部 1是 0否 (integer query )
     * source source, (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listHeaderTeacherGraduatePer",
        p,
        c
      ),
  },
  statisticsClassification_listClueStatusForNet: {
    /*
     * 网销部线索各个状态情况
     * timeType 时间类型 (string query )
     * start 开始 (string query )
     * end 结束 (string query )
     * clueType 线索业务类型 (string query )
     * originChannel 来源渠道 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listClueStatusForNet",
        p,
        c
      ),
  },
  statisticsClassification_listByAdminId: {
    /*
     * 根据登陆管理员获取可以查看的统计分类
     * platform 平台 (string query )
     * showName 显示名字 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/listByAdminId", p, c),
  },
  statisticsClassification_listAdultExamTestStatistics: {
    /*
     * 成教摸底考试首页统计
     * classificationId 分类id (integer query required)
     * year 成考年度 (string query required)
     * siteId 学校id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listAdultExamTestStatistics",
        p,
        c
      ),
  },
  statisticsClassification_listAdultExamTestHeaderTeacher: {
    /*
     * 成教摸底考试首页统计-班主任列表
     * year 成考年度 (string query required)
     * siteId 学校id (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/listAdultExamTestHeaderTeacher",
        p,
        c
      ),
  },
  statisticsClassification_getSuperAdminIds: {
    /*
     * 获取超级名单id
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/getSuperAdminIds",
        p,
        c
      ),
  },
  statisticsClassification_getPositions: {
    /*
     * 获取角色名单列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getPositions", p, c),
  },
  statisticsClassification_getLeveInfo: {
    /*
     * 获得层级信息
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getLeveInfo", p, c),
  },
  statisticsClassification_getAdminIds: {
    /*
     * 获取名单id列表
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/statisticsClassification/getAdminIds", p, c),
  },
  statisticsClassification_adultStudentEnrollAdultForExport: {
    /*
     * 继教院报名成教首页统计, 点击数字导出
     * level 继教院层次 (string query required)
     * siteId siteId (integer query )
     * headerTeacherId headerTeacherId (integer query )
     * province 继教院省份 (string query )
     * type type 0 服务学生数量，1 已有成教合同学生数量，2 待报数量，3 待异动学生数量，4 永久不报数量，5 本年不报数量，6 本年已报数量 (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/statisticsClassification/adultStudentEnrollAdultForExport",
        p,
        c
      ),
  },

  /**
   * 数据缓存
   */
  dataCache_refresh: {
    /*
     * 刷新缓存
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     */
    put: (p, c) => $.put("/api/bms/statistics/dataCache/refresh", p, c),
  },
  dataCache_refreshWithTimeType: {
    /*
     * 刷新缓存,参数仅为时间类型
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * liveStatus 流失状态, 或其他参数值，比如驻点线索的批次， 字段名先不改了 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshWithTimeType", p, c),
  },
  dataCache_refreshWithAdmin: {
    /*
     * 刷新缓存-针对每个人查看的数据范围不同
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshWithAdmin", p, c),
  },
  dataCache_refreshNetClueMainInfo: {
    /*
     * 刷新缓存,营销平台-网络线索统计和转化
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * extraParams 额外参数，推广渠道+省份，或部门id (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshNetClueMainInfo", p, c),
  },
  dataCache_refreshMainServiceData: {
    /*
     * 测试刷新缓存-数据情况缓存
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshMainServiceData", p, c),
  },
  dataCache_refreshForAdultEnroll: {
    /*
     * 刷新缓存,成教招生数据
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * type 类型：学校维度|层次维度 (string query required)
     * batch 批次 (string query )
     * peer 是否同行 (string query )
     * liveStatus 流失状态 (string query )
     */
    put: (p, c) =>
      $.put("/api/bms/statistics/dataCache/refreshForAdultEnroll", p, c),
  },
  dataCache_getUpdateTime: {
    /*
     * 获取最近刷新的时间
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/dataCache/getUpdateTime", p, c),
  },
  dataCache_getUpdateTimeWithTimeType: {
    /*
     * 获取最近刷新的时间
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeWithTimeType", p, c),
  },
  dataCache_getUpdateTimeWithAdmin: {
    /*
     * 获取最近刷新的时间-目前仅针对listMainInfoForService方法刷新缓存
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * requestParams 参数(协商好顺序，用逗号隔开，列表是|分割) (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeWithAdmin", p, c),
  },
  dataCache_getUpdateTimeForPromoterChannel: {
    /*
     * 获取最近刷新的时间-推广人渠道统计
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * param 日期或月份 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataCache/getUpdateTimeForPromoterChannel",
        p,
        c
      ),
  },
  dataCache_getUpdateTimeForNetClueMainInfo: {
    /*
     * 获取最近刷新的时间-营销平台-网络线索转化
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * extraParams 额外参数，推广渠道+省份，或部门id (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataCache/getUpdateTimeForNetClueMainInfo",
        p,
        c
      ),
  },
  dataCache_getUpdateTimeForAdultEnroll: {
    /*
     * 获取最近刷新的时间-成教招生数据
     * requestPath 接口地址，就是最后的方法，前面都不需要 (string query required)
     * timeType 时间类型 (string query )
     * type 类型：学校维度|层次维度 (string query required)
     * batch 批次 (string query )
     * peer 是否同行 (string query )
     * liveStatus 流失状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataCache/getUpdateTimeForAdultEnroll", p, c),
  },

  /**
   * 中军线索和业绩统计相关
   */
  promote_saveConvertorConfig: {
    /*
     * 中军线索转化人配置保存
     * content 内容 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/promote/saveConvertorConfig", p, c),
  },
  promote_statisticsForExceptionDegreeDataBoard: {
    /*
     * 中军统计数据看板
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * liveStatus 流失状态 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/statisticsForExceptionDegreeDataBoard",
        p,
        c
      ),
  },
  promote_statisticsClueCreateByCodeOutpost: {
    /*
     * 中军驻点线索统计数据看板
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 退伍批次 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/statisticsClueCreateByCodeOutpost",
        p,
        c
      ),
  },
  promote_statisticsClueCreateByCodeConvert: {
    /*
     * 中军线索转化统计看板
     * classificationId 分类id (integer query required)
     * timeType 时间类型 (string query )
     * batch 退伍批次 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/statisticsClueCreateByCodeConvert",
        p,
        c
      ),
  },
  promote_listSiteEnrollData: {
    /*
     * 学校招生数据
     * classificationId 分类id (integer query required)
     * province 省份 (string query )
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/promote/listSiteEnrollData", p, c),
  },
  promote_listLineChartData: {
    /*
     * 折线图
     * classificationId 分类id (integer query required)
     * monthOrYearSelected 类型：year或month (string query required)
     * province 省份 (string query )
     * siteId 学校 (integer query )
     * searchType 类型：全部、1月、2月。。。 (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/promote/listLineChartData", p, c),
  },
  promote_listGlobalStatsDeptEnrollData: {
    /*
     * 整体数据
     * classificationId 分类id (integer query required)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/promote/listGlobalStatsDeptEnrollData", p, c),
  },
  promote_getConvertorConfig: {
    /*
     * 中军线索转化人配置获取
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/promote/getConvertorConfig", p, c),
  },
  promote_exportForExceptionDegreeDataBoard: {
    /*
     * 中军统计数据看板, 点击数字导出
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * siteTypes 学校类型,多选 (array query )
     * type 类型:订单量|全款量|现金流|销售额 (string query )
     * liveStatus 流失状态 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/promote/exportForExceptionDegreeDataBoard",
        p,
        c
      ),
  },

  /**
   * 上交高校统计配置
   */
  handSchoolConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/handSchoolConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/handSchoolConfig", p, c),
  },
  handSchoolConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/statistics/handSchoolConfig/list", p, c),
  },
  handSchoolConfig_listSimple: {
    /*
     * 简易列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/handSchoolConfig/listSimple", p, c),
  },

  /**
   * 员工招生指标
   */
  employeeTarget: {
    /*
     * 添加编辑
     * target  ( query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/employeeTarget", p, c),

    /*
     * 删除
     * id ID (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/statistics/employeeTarget", p, c),
  },
  employeeTarget_uploadVocational: {
    /*
     * 批量导入职教线上招生指标
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/employeeTarget/uploadVocational", p, c),
  },
  employeeTarget_uploadArmy: {
    /*
     * 批量导入中军招生指标
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/employeeTarget/uploadArmy", p, c),
  },
  employeeTarget_listVocational: {
    /*
     * 职教线上招生指标列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/employeeTarget/listVocational", p, c),
  },
  employeeTarget_listArmy: {
    /*
     * 中军招生指标列表
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeTarget/listArmy", p, c),
  },
  employeeTarget_exportVocational: {
    /*
     * 导出职教线上招生指标
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/employeeTarget/exportVocational", p, c),
  },
  employeeTarget_exportArmy: {
    /*
     * 导出中军招生指标
     */
    get: (p, c) => $.get("/api/bms/statistics/employeeTarget/exportArmy", p, c),
  },

  /**
   * DataEase接口
   */
  dataEase_uploadGmvTarget: {
    /*
     * 导入Gmv指标
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/dataEase/uploadGmvTarget", p, c),
  },
  dataEase_setHealthPartnerCountyTarget: {
    /*
     * 设置健康度合作区县配置
     * actual  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/dataEase/setHealthPartnerCountyTarget", p, c),
  },
  dataEase_setHealthIndicatorTarget: {
    /*
     * 设置健康度分组指标配置
     * month 月份:1,2...12 (string query required)
     * target  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/dataEase/setHealthIndicatorTarget", p, c),
  },
  dataEase_setGmvTarget: {
    /*
     * 设置Gmv指标
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/dataEase/setGmvTarget", p, c),
  },
  dataEase_setExtraGmv: {
    /*
     * 设置额外Gmv
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     * data  ( query required)
     */
    post: (p, c) => $.post("/api/bms/statistics/dataEase/setExtraGmv", p, c),
  },
  dataEase_setAdultFollowConfig: {
    /*
     * 设置成教催费配置
     * config  ( query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/dataEase/setAdultFollowConfig", p, c),
  },
  dataEase_statisticsForContinueReport: {
    /*
     * 职教汇报数据
     * startTime 传每月1号时分秒 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/statisticsForContinueReport", p, c),
  },
  dataEase_statisticsForArmyReport: {
    /*
     * 中军汇报数据
     * startTime 传每月1号时分秒 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/statisticsForArmyReport", p, c),
  },
  dataEase_repairExtraGmv: {
    /*
     * 修复
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/repairExtraGmv", p, c),
  },
  dataEase_promoterChannelStatisticsByMonth: {
    /*
     * 推广人渠道统计-月统计
     * yearMonth 月份，格式yyyy-MM (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/promoterChannelStatisticsByMonth",
        p,
        c
      ),
  },
  dataEase_promoterChannelStatisticsByDay: {
    /*
     * 推广人渠道统计-日统计
     * date 日期，格式yyyy-MM-dd (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/promoterChannelStatisticsByDay",
        p,
        c
      ),
  },
  dataEase_listTeam: {
    /*
     * 获取团队列表
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/listTeam", p, c),
  },
  dataEase_listEnrollTeacher: {
    /*
     * 获取招生老师列表
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     * team 团队名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/listEnrollTeacher", p, c),
  },
  dataEase_listAdultFollowName: {
    /*
     * 成教催费名称列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/listAdultFollowName", p, c),
  },
  dataEase_healthIndicatorStatistics: {
    /*
     * 健康度统计
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/healthIndicatorStatistics", p, c),
  },
  dataEase_gmvStatisticsInfo: {
    /*
     * gmv统计
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/gmvStatisticsInfo", p, c),
  },
  dataEase_getHealthPartnerCountyTarget: {
    /*
     * 获取健康度合作区县配置
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/getHealthPartnerCountyTarget", p, c),
  },
  dataEase_getHealthIndicatorTarget: {
    /*
     * 获取健康度分组指标配置
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/getHealthIndicatorTarget", p, c),
  },
  dataEase_getGmvTarget: {
    /*
     * 获取Gmv指标
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/getGmvTarget", p, c),
  },
  dataEase_getExtraGmv: {
    /*
     * 获取额外Gmv
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/getExtraGmv", p, c),
  },
  dataEase_getCurrentAdultFollowName: {
    /*
     * 获取当前成教催费名称
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/getCurrentAdultFollowName", p, c),
  },
  dataEase_getAdultFollowConfig: {
    /*
     * 获取成教催费配置
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/getAdultFollowConfig", p, c),
  },
  dataEase_exportHealthIndicatorDetail: {
    /*
     * 健康度详情导出
     * month 月份:1,2...12 (string query required)
     * team 组名 (string query required)
     * type 类型：当月,累计 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/exportHealthIndicatorDetail", p, c),
  },
  dataEase_exportGmvTarget: {
    /*
     * 导出Gmv指标
     * type 类型：业绩，催费 (string query required)
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/exportGmvTarget", p, c),
  },
  dataEase_exportGmvData: {
    /*
     * gmv数据导出
     * type 类型：业绩，催费 (string query required)
     * monthType 月份类型：当月、总计 (string query required)
     * month 月份:1,2...12 (string query required)
     * team 队伍 (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/dataEase/exportGmvData", p, c),
  },
  dataEase_exportCapitalFlowData: {
    /*
     * 资金流详情数据导出
     * month 月份:1,2...12 (string query required)
     * type 类型：累计，当月 (string query required)
     * team 队伍 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/exportCapitalFlowData", p, c),
  },
  dataEase_exportAdultFollowDetailInfoForTeam: {
    /*
     * 战队催费数据导出
     * name 催费名称 (string query required)
     * teamName 战队名称 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/exportAdultFollowDetailInfoForTeam",
        p,
        c
      ),
  },
  dataEase_continueEducationComparisonStatistics: {
    /*
     * 继教院批次对比统计
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/dataEase/continueEducationComparisonStatistics",
        p,
        c
      ),
  },
  dataEase_capitalFlowStatisticsInfo: {
    /*
     * 资金流统计
     * month 月份:1,2...12 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/capitalFlowStatisticsInfo", p, c),
  },
  dataEase_adultFollowStatisticsSubInfo: {
    /*
     * 成教催费统计子信息
     * name 催费名称 (string query required)
     * dimensions 维度：学校、战队 (string query required)
     * groupName 组名称 (string query required)
     * subGroup 子组名称 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/adultFollowStatisticsSubInfo", p, c),
  },
  dataEase_adultFollowStatisticsInfo: {
    /*
     * 成教催费统计
     * name 催费名称 (string query required)
     * dimensions 维度：学校、战队 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/adultFollowStatisticsInfo", p, c),
  },
  dataEase_adultFollowDetailInfoForTeam: {
    /*
     * 战队催费数据详情
     * name 催费名称 (string query required)
     * teamName 战队名称 (string query required)
     * type 类型 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/dataEase/adultFollowDetailInfoForTeam", p, c),
  },

  /**
   * 继教院业绩首页
   */
  continue_saveContinueEnrollConfig: {
    /*
     * 继教院汇报数据-保存招生系数配置
     * content Json字符串 (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/statistics/continue/saveContinueEnrollConfig", p, c),
  },
  continue_statisticsForContinueSchooling: {
    /*
     * 继教院每月在读情况
     * classificationId 分类id (integer query required)
     * year 年份 (integer query )
     * month 月份 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueSchooling",
        p,
        c
      ),
  },
  continue_statisticsForContinueSchoolingExport: {
    /*
     * 继教院每月在读情况, 点击数字导出
     * id 列表返回的ID (integer query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/statisticsForContinueSchoolingExport",
        p,
        c
      ),
  },
  continue_listStatsContinueSiteServiceData: {
    /*
     * 继教院服务-学校服务数据
     * batch 批次 (string query )
     * source 渠道（线上、线下、同行、非同行 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listStatsContinueSiteServiceData",
        p,
        c
      ),
  },
  continue_listStatsContinueSiteEnrollData: {
    /*
     * 继教院业绩-学校招生数据
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 批次 (string query )
     * level 层次 (string query )
     * source 渠道（线上、线下、同行、非同行 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listStatsContinueSiteEnrollData",
        p,
        c
      ),
  },
  continue_listSiteForContinueLoss: {
    /*
     * 职教流失情况学校列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listSiteForContinueLoss", p, c),
  },
  continue_listFollowForContinue: {
    /*
     * 继教院续读情况
     * batch 批次 (string query )
     * level 层次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listFollowForContinue", p, c),
  },
  continue_listFollowDetailForContinue: {
    /*
     * 继教院续读情况
     * batch 批次 (string query required)
     * site 学校 (string query required)
     * level 层次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listFollowDetailForContinue", p, c),
  },
  continue_listContinueTeacherEnrollData: {
    /*
     * 继教院业绩-学校招生数据(个人排行)
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * siteId 院校 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueTeacherEnrollData", p, c),
  },
  continue_listContinueSiteServiceData: {
    /*
     * 继教院服务-学校服务数据饼图
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueSiteServiceData", p, c),
  },
  continue_listContinueSiteAdmissionsRanking: {
    /*
     * 继教院业绩-学校招生数据饼图
     * timeType 时间类型 (string query )
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueSiteAdmissionsRanking",
        p,
        c
      ),
  },
  continue_listContinueLoss: {
    /*
     * 职教学生流失情况
     * site 学校 (string query )
     * batch 批次 (string query )
     */
    get: (p, c) => $.get("/api/bms/statistics/continue/listContinueLoss", p, c),
  },
  continue_listContinueLineChartData: {
    /*
     * 继教院业绩-折线图
     * type 类型：全部、1月、2月。。。 (string query required)
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 批次 (string query )
     * sources 来源详情：线上、老带新、新带新、电销、院校直招、同行 (array query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueLineChartData", p, c),
  },
  continue_listContinueLineChartDataForService: {
    /*
     * 继教院服务-折线图
     * type 类型：全部、1月、2月。。。 (string query required)
     * start 开始时间 (string query )
     * end 结束时间 (string query )
     * batch 批次 (string query )
     * source 来源详情：线上，线下，同行，非同行，全部 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueLineChartDataForService",
        p,
        c
      ),
  },
  continue_listContinueHeaderTeacherServiceInfo: {
    /*
     * 继教院服务-班主任带班情况
     * siteId 学校 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listContinueHeaderTeacherServiceInfo",
        p,
        c
      ),
  },
  continue_listContinueEnrollConfig: {
    /*
     * 继教院汇报数据-查看招生系数配置
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listContinueEnrollConfig", p, c),
  },
  continue_listBatchForContinueLoss: {
    /*
     * 职教流失情况批次列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/listBatchForContinueLoss", p, c),
  },
  continue_listAdultFollowDetailForContinue: {
    /*
     * 继教院成教续读情况
     * batch 批次 (string query required)
     * site 学校 (string query )
     * level 层次 (string query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/listAdultFollowDetailForContinue",
        p,
        c
      ),
  },
  continue_exportReportStudentLossInfo: {
    /*
     * 导出汇报学生流失情况
     * site 学校 (string query )
     * batch 批次 (string query )
     * schoolStatus 学籍状态 (string query )
     * lossType 流失状态：未流失，第一年流失.. (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/exportReportStudentLossInfo", p, c),
  },
  continue_exportFollowStudentForContinue: {
    /*
     * 导出继教院续读学生列表
     * batch 批次 (string query required)
     * site 学校 (string query )
     * level 层次 (string query )
     * adultBatch 成教批次 (string query )
     * type 类型：报名量、报道量、未报学历量、报成教学历量、报自考学历量、同时报名量 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/continue/exportFollowStudentForContinue",
        p,
        c
      ),
  },
  continue_exportContinueLoss: {
    /*
     * 导出职教学生流失情况
     * site 学校 (string query )
     * batch 批次 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/continue/exportContinueLoss", p, c),
  },

  /**
   * 同行首页统计数据
   */
  peer_listStatisticsForPeerSchoolStatus: {
    /*
     * 同行首页统计数据-学籍状态维度
     * batch 批次下拉, 学历批次 (string query )
     * siteId 学校ID，下拉 (integer query )
     * majorId 专业ID，下拉 (integer query )
     * schoolStatus 学籍状态，下拉 (string query )
     * enrollTeacherId 招生老师ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listStatisticsForPeerSchoolStatus", p, c),
  },
  peer_listStatisticsForPeerBySite: {
    /*
     * 同行首页统计数据-学校维度
     * batch 批次下拉, 学历批次 (string query )
     * siteId 学校ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listStatisticsForPeerBySite", p, c),
  },
  peer_listStatisticsForPeerByEnrollTeacher: {
    /*
     * 同行首页统计数据-招生老师维度
     * batch 批次下拉, 学历批次 (string query )
     * enrollTeacherId 同行-招生老师ID，下拉 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/bms/statistics/peer/listStatisticsForPeerByEnrollTeacher",
        p,
        c
      ),
  },
  peer_listSimpleSiteForPeer: {
    /*
     * 学校下拉列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listSimpleSiteForPeer", p, c),
  },
  peer_listSimpleEnrollTeacherForPeer: {
    /*
     * 招生老师下拉列表
     */
    get: (p, c) =>
      $.get("/api/bms/statistics/peer/listSimpleEnrollTeacherForPeer", p, c),
  },
};
